import React from 'react';
import { Box, IconButton } from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { BRAND, GRADIENT } from '../theme';

// BridgeArrow
//
// Animated arrow between source + destination ChainPickers. Clicking it
// invokes onSwap (typical UX: swap source ↔ destination chain ids). On
// xs/sm the arrow rotates 90° via `vertical` prop.

export default function BridgeArrow({ onSwap, vertical = false }) {
  return (
    <Box
      sx={{
        display: 'grid',
        placeItems: 'center',
        flexShrink: 0,
        position: 'relative',
        my: vertical ? 1 : 0,
        mx: vertical ? 0 : 1,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: -6,
          borderRadius: '50%',
          background: GRADIENT,
          opacity: 0.25,
          filter: 'blur(8px)',
          animation: 'bridgePulse 2.2s ease-in-out infinite',
          '@keyframes bridgePulse': {
            '0%, 100%': { transform: 'scale(1)', opacity: 0.2 },
            '50%':      { transform: 'scale(1.18)', opacity: 0.45 },
          },
        }}
      />
      <IconButton
        onClick={onSwap}
        aria-label="Swap source and destination"
        sx={{
          width: 44,
          height: 44,
          background: GRADIENT,
          color: '#fff',
          boxShadow: `0 6px 20px ${BRAND.violet}55`,
          '&:hover': {
            background: GRADIENT,
            filter: 'brightness(1.15)',
            transform: 'rotate(180deg)',
            transition: 'transform 220ms ease',
          },
          transition: 'transform 220ms ease',
        }}
        data-testid="bridge-arrow"
      >
        {vertical ? <SwapVertIcon /> : <SwapHorizIcon />}
      </IconButton>
    </Box>
  );
}
